export default __webpack_public_path__ + "static/media/img_04.f72ddd6e.png";